module.exports = __webpack_public_path__ + "static/media/ruleImg1.3f8f2744.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ruleImg1.png
// module id = 1852
// module chunks = 0 1